
// esta funcion permite saber que elementos tienen permiso para mostrarse.
// se usa en varios componentes 
export default {
  methods: {
    can(key) {
      const userPermissions = JSON.parse(localStorage.getItem("asegurables"));
          if (userPermissions) {
            return userPermissions.includes(key);
          }
          return false
        },
  },
};
